<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>
<script>

export default {

  components: {
  },

  data() {
    return {
    }
  }
}
</script>

<style>
body {
  background-color: #F1F6FE
}
</style>
